export default {
  stepper: {
    description: 'Incorporación del restaurante',
    steps: {
      confirm_email: 'Confirmar dirección de email',
      add_store_details: 'Añade los detalles de tu tienda',
      add_personal_details: 'Añade tu información personal',
      add_bank_details: 'Añade datos bancarios para cobros',
      add_tax_details: '¿Tu empresa está registrada en el IVA?',
      upload_business_doc: 'Documento acreditativo de empresa',
      upload_personal_doc: 'Documento de identidad',
      confirm_details: 'Recibir pagos',
    },
  },
  completed: {
    title: 'Incorporación completada',
    description:
      'Tu incorporación ha finalizado. Puedes añadir documentos aquí en cualquier momento, por ejemplo el DNI de un nuevo socio o un DNI renovado.',
  },
  toasts: {
    failed_to_skip_verification_step: 'Error al omitir el paso de verificación. Inténtalo de nuevo',
  },
};
